import { HARDWARE_VERSIONS } from "@teamtable/api";
import { useState } from "react";

import { apiClient } from "../api/client.js";

export function DeviceHardware({
  id,
  version,
  canEdit,
  onSaved,
}: {
  id: string;
  version?: string | null;
  canEdit: boolean;
  onSaved: () => void | Promise<void>;
}) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  return (
    <div className="mb-4">
      <label className="block text-sm text-text-secondary mb-1" htmlFor="hardware-version">
        Table Hardware Version
      </label>
      <select
        id="hardware-version"
        value={version ?? ""}
        disabled={!canEdit || busy}
        className="bg-surface border border-border rounded-md p-2"
        onChange={async (e) => {
          setBusy(true);
          setMessage("");
          try {
            const res = await apiClient["/api/v1/admin/devices/{id}"].patch({
              parameters: { id },
              body: { hardware_version: e.target.value || null },
            });
            if (res.code === 200) await onSaved();
            else setMessage("Could not save hardware version.");
          } catch {
            setMessage("Could not save hardware version.");
          } finally {
            setBusy(false);
          }
        }}
      >
        <option value="">Unknown</option>
        {version && !HARDWARE_VERSIONS.some((id) => id === version) && (
          <option value={version}>Unknown ({version})</option>
        )}
        {HARDWARE_VERSIONS.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
      {message && <p role="status">{message}</p>}
    </div>
  );
}
